import { AuthServiceImpl } from './auth-service-impl';
import { makeEnvironment } from 'src/environments/make-environment';

let authServiceInstance: AuthServiceImpl | null = null;

export const makeAuthService = () => {
  if (!authServiceInstance) {
    const env = makeEnvironment();
    authServiceInstance = new AuthServiceImpl(env);
  }

  return authServiceInstance;
};
